import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  exports: [],
  entryComponents: [],
  imports: [
    CommonModule
  ]
})
export class LcuElementsModule { }
